import { Col, Divider, Row, message } from "antd";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PAYMENT, RATING, UPLOADS_URL } from "../../config/constants/api";
import { useLocation, useNavigate } from "react-router-dom";
import { extractDate, ImageUrl } from "../../config/helpers";
import { Get } from "../../config/api/get";

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};
const beforeUpload = (file) => {
  const isImage = file.type.startsWith("image/");
  if (!isImage) {
    message.error("Invalid Uplaod, You can only upload image files!");
  }
  return isImage;
};

const EditProfile = () => {
  const [ratings, setRatings] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector((state) => state.user.userData);
  const showButtons = location?.state?.showButtons;
  const [paymentMethods, setPaymentMethods] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const getClientPaymentMetods = async () => {
    Get(PAYMENT.getClientPaymentMetods, token)
      .then((response) => {
        if (response?.status) {
          setPaymentMethods(response?.data?.data);
        }
      })
      .catch((err) => {
        console.log(err, "Error fetching payment methods");
      });
  };
  const getPaymentProfiles = async () => {
    Get(PAYMENT.getPaymentProfiles, token)
      .then((response) => {
        if (response?.status) {
          setPaymentMethods(response?.data?.paymentProfiles);
        }
      })
      .catch((err) => {
        console.log(err, "Error fetching payment methods");
      });
  };
  useEffect(() => {
    if (!showButtons) {
      getPaymentProfiles();
      // getClientPaymentMetods();
    }
  }, []);
  const getUserById = () => {
    Get(`${RATING.getUserRatings}${userData?._id}`, token)
      .then((response) => {
        if (response?.status) {
          setRatings(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    getUserById();
  }, []);
  let imageUrl = UPLOADS_URL + userData?.image 
  return (
    <Row justify="center" className="py-16 max-sm:py-8 bg-white">
      <Col md={12} sm={22} xs={22}>
        <FaArrowLeftLong
          className="arrow cursor-pointer"
          onClick={() => navigate(-1)}
        />
        <Row justify="center">
          <h3 className="font-tavi text-3xl text-black max-sm:text-xl font-semibold">
            Profile
          </h3>
        </Row>
        <Row justify="center" className="mb-12">
          <Col xxl={10} xl={14} md={18} sm={24} xs={24}>
            <div className="flex flex-col justify-center items-center mt-6 bg-white py-8 px-6 rounded-lg shadow-lg">
              <img
                src={(!imageUrl || imageUrl.includes('null')) ? ImageUrl('avatar.png') : imageUrl}
                alt="User Avatar"
                style={{
                  height: "100px",
                  width: "100px",
                  borderRadius: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
              <h5 className="my-2 text-center font-euclid text-sm font-semibold text-customBlack">
                {userData?.firstName} {userData?.lastName}
              </h5>
              <Divider />
              <div className="flex justify-center items-center mt-3">
                {/* <p className="font-euclid text-sm font-bold text-customBlack text-center px-8 max-sm:px-4 border-r border-gray-200">
                  50+ <br />
                  <span className="text-xs font-semibold">Rides</span>
                </p> */}
                <div className="font-euclid text-sm font-bold text-customBlack text-center px-8 max-sm:px-4  border-gray-200 flex flex-col justify-center items-center">
                  <div className="flex justify-center">
                    <FaStar className="mr-1 text-customGold" />{" "}
                    {ratings?.averageRating ? ratings?.averageRating : "0"}
                  </div>
                  <span className="text-xs font-semibold">Rating</span>
                </div>
                {/* <p className="font-euclid text-sm font-bold text-customBlack text-center px-8 max-sm:px-4 ">
                  4.2 <br />
                  <span className="text-xs font-semibold">Years</span>
                </p> */}
              </div>
            </div>
          </Col>
        </Row>
        <Divider />

        <Row justify="center" className="mt-12">
          <h5 className="font-tavi text-2xl text-black mb-8 max-sm:text-lg font-semibold">
            Personal Profile
          </h5>
          <div className="bg-white py-4 px-8 rounded-lg shadow-lg w-full">
            <Row gutter={[16, 16]}>
              <Col lg={12} md={12} xs={24}>
                <div>
                  <h6 className="font-euclid text-sm text-[#000] font-bold py-2">
                    First Name
                  </h6>
                  <p>{userData?.firstName}</p>
                </div>
              </Col>
              <Col lg={12} md={12} xs={24}>
                <div>
                  <h6 className="font-euclid text-sm text-[#000] font-bold py-2">
                    Last Name
                  </h6>
                  <p>{userData?.lastName}</p>
                </div>
              </Col>
              <Col lg={12} md={12} xs={24}>
                <div>
                  <h6 className="font-euclid text-sm text-[#000] font-bold py-2">
                    Email Address
                  </h6>
                  <p>{userData?.email}</p>
                </div>
              </Col>
              <Col lg={12} md={12} xs={24}>
                <div>
                  <h6 className="font-euclid text-sm text-[#000] font-bold py-2">
                    Phone Number
                  </h6>
                  <p>{userData?.phone}</p>
                </div>
              </Col>
              {/* <Col lg={12} md={12} xs={24}>
                <div>
                  <h6 className="font-euclid text-sm text-[#000] font-bold py-2">
                    Gender
                  </h6>
                  <p>{userData?.gender}</p>
                </div>
              </Col> */}
              {/* <Col lg={12} md={12} xs={24}>
                 <div
                  >
                    <h6 className="font-euclid text-sm text-[#000] font-bold py-2">Location</h6>
                    <p>abc</p>
                  </div>
                </Col> */}
              {/* <Col lg={12} md={12} xs={24}>
                <div>
                  <h6 className="font-euclid text-sm text-[#000] font-bold py-2">
                    Date of Birth
                  </h6>
                  <p>{extractDate(userData?.dateOfBirth)}</p>
                </div>
              </Col> */}
            </Row>
          </div>
        </Row>
        {showButtons && (
          <div className="flex justify-center gap-4">
            <button
              htmlType=""
              className="uppercase bg-button px-4 py-4  text-white rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 mt-6"
              onClick={() => navigate("/editProfile")}
            >
              Edit Profile
            </button>
            <button
              htmlType=""
              className="uppercase bg-button px-4 py-4  text-white rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 mt-6"
              onClick={() => navigate("/changePassword")}
            >
              Change Password
            </button>
          </div>
        )}
        {/* {Array.isArray(paymentMethods) && paymentMethods.length > 0 && (
          <h2 className="font-tavi text-3xl text-black max-sm:text-xl font-semibold pt-4" style={{ paddingBottom: "10px" }}>Your Existing Cards Info</h2>
        )}
        {!showButtons && Array.isArray(paymentMethods) && <div className="bg-white py-4 px-8 rounded-lg shadow-lg w-full">
          {Array.isArray(paymentMethods) && paymentMethods.length > 0 && (
            <div className="card-list" style={{ marginTop: "20px" }}>
              {paymentMethods.map((method) => (
                <div
                  key={method.id}
                  className="card-item"
                  style={{
                    border: "2px solid #fff",
                    padding: "10px",
                    borderRadius: "12px",
                    width: "100%",
                    fontWeight: "bold",
                    boxShadow: "1px 2px 2px #fff",
                  }}
                >
                  <div className="card-brand">
                    Brand : {method.card.brand.toUpperCase()}
                  </div>
                  <div className="card-last4">
                    Card Number : **** **** **** {method.card.last4}
                  </div>
                  <div className="card-expiry">
                    Expiration Date : {method.card.exp_month}/
                    {method.card.exp_year}
                  </div>
                  <div className="card-brand">
                    Country : {method.card.country}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>} */}

        {Array.isArray(paymentMethods) && paymentMethods.length > 0 && (
          <h2
            className="font-tavi text-3xl text-black max-sm:text-xl font-semibold pt-4"
            style={{ paddingBottom: "10px" }}
          >
            Your Existing Cards Info
          </h2>
        )}
        {!showButtons && Array.isArray(paymentMethods) && (
          <div className="bg-white py-4 px-8 rounded-lg shadow-lg w-full">
            {Array.isArray(paymentMethods) && paymentMethods.length > 0 && (
              <div className="card-list" style={{ marginTop: "20px" }}>
                {paymentMethods.map((method, index) => (
                  <div
                    key={index}
                    className="card-item"
                    style={{
                      border: "2px solid #fff",
                      padding: "10px",
                      borderRadius: "12px",
                      width: "100%",
                      fontWeight: "bold",
                      boxShadow: "1px 2px 2px #fff",
                    }}
                  >
                    <div className="card-brand">
                      Card Type : {method?.payment?.creditCard?.cardType}
                    </div>
                    <div className="card-last4">
                      Card Number : **** **** ****{" "}
                      {method?.payment?.creditCard?.cardNumber.slice(-4)}
                    </div>
                    <div className="card-expiry">
                      Expiration Date :{" "}
                      {method?.payment?.creditCard?.expirationDate}
                    </div>
                    {/* <div className="card-brand">
                    Country : {method.card.country}
                  </div> */}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default EditProfile;
